import { FC } from 'react';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { CustomTooltip } from '@mybonum/ui';
import { Button } from 'antd';
import clsx from 'clsx';

import styles from './styles.module.scss';

import { useSidebarContext } from '@/contexts/sidebar';

export const ToggleButton: FC = () => {
    const { collapsed, toggleCollapsed } = useSidebarContext();
    const Icon = collapsed ? MenuUnfoldOutlined : MenuFoldOutlined;
    const tooltipTitle = collapsed ? 'Expand sidebar' : 'Collapse sidebar';
    const buttonText = collapsed ? 'Expand Sidebar' : 'Collapse Sidebar';

    const button = (
        <Button
            className={clsx(styles.button, { [styles.collapsed]: collapsed })}
            variant="text"
            color="primary"
            onClick={toggleCollapsed}
            icon={<Icon />}
        >
            {!collapsed && buttonText}
        </Button>
    );

    if (collapsed) {
        return (
            <CustomTooltip title={tooltipTitle} placement="right">
                {button}
            </CustomTooltip>
        );
    }

    return button;
};
